/** Archive air dates are calendar dates, so a viewer's timezone must not move them. */
export function formatSourceDate(date: string | null | undefined): string | null {
  if (date == null) return null;
  const calendarDate = /^\d{4}-\d{2}-\d{2}$/.test(date);
  const parsed = new Date(calendarDate ? `${date}T00:00:00Z` : date);
  if (Number.isNaN(parsed.getTime())) return date;
  // Date accepts values such as February 30 by rolling into March. Preserve
  // malformed source text instead of presenting that invented date as fact.
  if (calendarDate && (parsed.getUTCFullYear() < 1 || parsed.toISOString().slice(0, 10) !== date)) return date;
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric", month: "short", day: "numeric",
    ...(calendarDate ? { timeZone: "UTC" } : {})
  }).format(parsed);
}
